import React, { useEffect, useState } from "react";
import { api, brl } from "../lib/api";
import { Trophy, ShieldCheck, Star, TrendUp, DownloadSimple } from "@phosphor-icons/react";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

const PODIUM = [
  { label: "Maior Vendedora",     key: "top_volume",      Icon: Trophy,        accent: "#C5A566", fmt: (r) => brl(r.monthly_volume),       sub: (r) => `${r.clients_count} cliente(s)`, adminOnlyValue: true },
  { label: "Menor Inadimplencia", key: "top_low_default", Icon: ShieldCheck,   accent: "#7B9D7E", fmt: (r) => `${r.default_rate}%`,         sub: (r) => `${r.clients_count} cliente(s)` },
  { label: "Melhor Score Medio",  key: "top_score",       Icon: Star,          accent: "#DDA7A5", fmt: (r) => `${r.avg_client_score}`,     sub: (r) => `${r.clients_count} cliente(s)` },
  { label: "Maior Crescimento",   key: "top_growth",      Icon: TrendUp,       accent: "#5C7CFA", fmt: (r) => `${r.growth_pct >= 0 ? "+" : ""}${r.growth_pct}%`, sub: (r) => `${r.clients_count} cliente(s)` },
];

const MEDALS = ["🥇", "🥈", "🥉"];

export default function RankingPodium() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => { (async () => setData((await api.get("/gamification/ranking")).data))(); }, []);

  const downloadCard = async (category) => {
    try {
      const res = await api.get(`/gamification/ranking/${category}/card.png`, { responseType: "blob" });
      const blobUrl = window.URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `cris-lingerie-ranking-${category}-${data.month}.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
      toast.success("Imagem pronta para Stories!");
    } catch { toast.error("Erro ao baixar"); }
  };

  if (!data) return null;
  const isAdmin = user?.role === "admin";

  return (
    <div data-testid="ranking-podium">
      <div className="flex items-center justify-between mb-1">
        <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">Ranking do mes · {data.month}</div>
        {isAdmin && (
          <div className="text-[10px] tracking-widest uppercase text-[#5C5A57]">
            Card pronto para Stories <DownloadSimple size={12} className="inline ml-1" />
          </div>
        )}
      </div>
      <h2 className="section-title mb-4">Top Revendedoras</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {PODIUM.map((cat) => {
          const Icon = cat.Icon;
          const items = data[cat.key] || [];
          return (
            <div key={cat.key} className="border border-[#EBE5DF] bg-white p-5 flex flex-col" data-testid={`podium-${cat.key}`}>
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                  <Icon size={20} weight="duotone" style={{ color: cat.accent }} />
                  <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57]">{cat.label}</div>
                </div>
                {isAdmin && items.length > 0 && (
                  <button
                    onClick={() => downloadCard(cat.key)}
                    className="text-[#5C5A57] hover:text-black"
                    title="Baixar card para Stories"
                    data-testid={`download-card-${cat.key}`}
                  >
                    <DownloadSimple size={16} />
                  </button>
                )}
              </div>
              <div className="space-y-3 flex-1">
                {items.length === 0 && <div className="text-xs text-[#5C5A57]">Sem dados ainda este mes.</div>}
                {items.map((r, i) => (
                  <div key={r.id + i} className="flex items-center justify-between">
                    <div className="flex items-center gap-2 min-w-0">
                      <span className="text-lg">{MEDALS[i]}</span>
                      <span className="text-sm font-medium truncate">{r.name}</span>
                    </div>
                    <span className="tabular text-sm font-bold whitespace-nowrap" style={{ color: cat.accent }}>{cat.adminOnlyValue && !isAdmin ? "" : cat.fmt(r)}</span>
                  </div>
                ))}
              </div>
              {isAdmin && items.length > 0 && (
                <button
                  onClick={() => downloadCard(cat.key)}
                  className="mt-4 pt-3 border-t border-[#EBE5DF] text-[10px] tracking-widest uppercase font-medium hover:underline flex items-center justify-center gap-1"
                  style={{ color: cat.accent }}
                  data-testid={`download-card-cta-${cat.key}`}
                >
                  <DownloadSimple size={12} /> Baixar para Instagram
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
